import { GetterTree } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'

const getters: GetterTree<FeatureFlagsState, IRootState> = {
  displayNewDesign: state => {
    return state?.flags?.newDesign
  },
}

export default getters
